export default "__VITE_ASSET__nPZnXYyi__"